import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductDetailComponent } from './product-list/product-detail/product-detail.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { BlogComponent } from './blog/blog.component';
import { BlogDetailComponent } from './blog/blog-detail/blog-detail.component';
import { FaqComponent } from './faq/faq.component';
import { CategoryWiseProductListComponent } from './product-list/category-wise-product-list/category-wise-product-list.component';
import { CatSubcatListComponent } from './category-list/cat-subcat-list/cat-subcat-list.component';
import { MainLayoutComponent } from '../../shared/components/layouts/main-layout/main-layout.component';
import { PrivateLayoutComponent } from '../../shared/components/layouts/private-layout/private-layout.component';
import { AuthGuard } from '../../core/guard/auth.guard';
import { SearchProductListComponent } from './product-list/search-product-list/search-product-list.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { HelpCenterComponent } from './help-center/help-center.component';
import { ShippingPolicyComponent } from './shipping-policy/shipping-policy.component';
import { CancellationRefundPolicyComponent } from './cancellation-refund-policy/cancellation-refund-policy.component';
import { DeliveryAppPrivacyPolicyComponent } from './delivery-app-privacy-policy/delivery-app-privacy-policy.component';
const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
  },
  {
    path: 'help-center',
    component: HelpCenterComponent,
  },
  {
    path: 'terms-conditions',
    component: TermsConditionsComponent,
  },
  {
    path: 'shipping-policy',
    component: ShippingPolicyComponent,
  },
  {
    path: 'cancellation-refund-policy',
    component: CancellationRefundPolicyComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'delivery-app-privacy-policy',
    component: DeliveryAppPrivacyPolicyComponent,
  },
  {
    path: 'faq',
    component: FaqComponent,
  },

  {
    path: 'blog',
    children: [
      { path: '', component: BlogComponent },
      { path: 'blog-detail', component: BlogDetailComponent },
    ],
  },
  {
    path: 'product',
    children: [
      { path: '', component: ProductListComponent },
      { path: ':slug/:slug/:productId', component: ProductDetailComponent },
    ],
  },
  {
    path: 's',
    children: [{ path: '', component: SearchProductListComponent }],
  },
  {
    path: 'search',
    children: [{ path: '', component: SearchProductListComponent }],
  },
  {
    path: 'cn',
    children: [
      {
        path: ':slug/:categoryId/:subCategoryId',
        component: CategoryWiseProductListComponent,
      },
    ],
  },
  {
    path: 'cat',
    children: [
      {
        path: 'sb/:slug',
        component: CatSubcatListComponent,
      },
    ],
  },
  {
    path: 'users',
    component: MainLayoutComponent,
    // canActivate: [noAuthGuard],
    children: [
      { path: '', redirectTo: 'account', pathMatch: 'full' },
      {
        path: 'account',
        loadChildren: () =>
          import('../authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
    ],
  },
  {
    path: 'users',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'account', pathMatch: 'full' },
      {
        path: 'account',
        loadChildren: () =>
          import('../user-management/user-management.module').then(
            (m) => m.UserManagementModule
          ),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebPortalRoutingModule {}
